<template>
    <div>
        <el-tabs v-model="activeName">
           <!-- <el-tab-pane label="目标周期阈值配置" name="first">
                <el-form :inline="true">
                    <el-form-item label="对账目标">
                        <el-input></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="showEdit = true">新增</el-button>
                    </el-form-item>
                </el-form>
                <el-form v-show="showEdit" :inline="true">
                    <el-form-item label="对账目标">
                        <el-input></el-input>
                    </el-form-item>
                    <el-form-item label="period">
                        <el-input></el-input>
                    </el-form-item>
                    <el-form-item label="threshold">
                        <el-input></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="closeEdit()">取消</el-button>
                        <el-button type="primary" @click="insertConf()">确定</el-button>
                    </el-form-item>
                </el-form>

                <el-table :data="confList">
                    <el-table-column label="对账目标" prop=""></el-table-column>
                    <el-table-column label="周期" prop=""></el-table-column>
                    <el-table-column label="阈值" prop=""></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination background layout="prev, pager, next" :total="confTotal" :page-size="15" :current-page="queryCondition.page"
                               @current-change="queryConfList"></el-pagination>
            </el-tab-pane>-->
            <el-tab-pane label="对账配置" name="second">
                <el-form :inline="true">
                    <el-form-item label="对账类别">
                        <el-select v-model="queryInfo.category" clearable>
                            <el-option v-for="item in categoryTypes" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户ID">
                        <el-input v-model="queryInfo.userId"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="queryReconConfList(1)">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="editType = 'insert',showConfEdit = true">新增</el-button>
                    </el-form-item>
                </el-form>

                <el-table :data="listInfo">
                    <el-table-column label="对账类别" prop="category"/>
                    <el-table-column label="UserId" prop="userId"/>
                    <el-table-column label="最小周期/H" prop="minPeriod"/>
                    <el-table-column label="对账类型">
                        <template slot-scope="scope">{{scope.row.leftType}}/{{scope.row.rightType}}</template>
                    </el-table-column>
                    <el-table-column label="对账小时点" prop="hour"/>
                    <el-table-column label="备注" prop="remark"/>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination background layout="prev, pager, next" :total="total" :page-size="15" :current-page="queryInfo.page" @current-change="queryReconConfList"/>

            </el-tab-pane>
        </el-tabs>

        <el-dialog title="对账配置" :visible.sync= "showConfEdit" @close="closeDialog">
             <el-form label-width="150px">
                 <el-form-item label="对账类别">
                     <el-select v-model="editInfo.category">
                         <el-option v-for="item in categoryTypes" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                     </el-select>
                 </el-form-item>
                 <el-form-item label="userId">
                     <el-input v-model="editInfo.userId"/>
                 </el-form-item>
                 <el-form-item label="最小周期">
                     <el-input v-model="editInfo.minPeriod"/>
                 </el-form-item>
                 <el-form-item label="对账左类型">
                     <el-select v-model="editInfo.leftType">
                         <el-option v-for="item in reconciliationType" :key="item.code" :label="item.desc" :value="item.code"/>
                     </el-select>
                 </el-form-item>
                 <el-form-item label="对账右类型">
                     <el-select v-model="editInfo.rightType">
                         <el-option v-for="item in reconciliationType" :key="item.code" :label="item.desc" :value="item.code"/>
                     </el-select>
                 </el-form-item>
                 <el-form-item label="对账小时点">
                     <el-input v-model="editInfo.hour"/>
                 </el-form-item>
                 <el-form-item label="备注">
                     <el-input v-model="editInfo.remark"/>
                 </el-form-item>
                 <el-form-item>
                     <el-button type="info" @click="closeDialog">取消</el-button>
                     <el-button type="primary" @click="submitConf">确认</el-button>
                 </el-form-item>
             </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import './store';
    import api from './api';
    import {mapActions, mapState} from 'vuex';
    export default {
        name: "accountConf",
        data(){
            return {
                showEdit: false,
                confInfo:{},
                queryCondition:{page:1},
                activeName:'second',
                queryInfo:{
                    category: '',
                    userId: '',
                    page:1
                },
                categoryTypes:[{code:'TOTAL',desc:'总数'},{code:'USER_PLATFORM',desc:'用户与平台'}],
                showConfEdit: false,
                editInfo:{
                    category:'',
                    userId:'',
                    minPeriod:'',
                    leftType:'',
                    rightType:'',
                    remark:'',
                    hour: '',
                },
                editType:'',
                reconciliationType:[{code:'ACCOUNT',desc:'账务记录'},{code:'BALANCE',desc:'余额'}]
            }
        },
        computed : {...mapState('account',['confTotal','confList','total','listInfo'])},
        methods:{
            ...mapActions('account',['queryReconConf']),
            closeEdit(){
                this.showEdit = false;
            },
            insertConf(){
                this.showEdit = false;
            },
            queryConfList(val){},
            queryReconConfList(val){
                this.queryInfo.page = val;
                this.queryReconConf(this.queryInfo);
            },
            closeDialog(){
                this.editType = '';
                this.editInfo = {};
                this.showConfEdit = false;
            },
            submitConf(){
                api.saveReconConf(this.editInfo).then(() =>{
                    this.$message.success('操作成功');
                    this.closeDialog();
                    this.queryReconConf(this.queryInfo);
                })
            },
            openEdit(info){
                this.editInfo = JSON.parse(JSON.stringify(info));
                this.editType = 'update';
                this.showConfEdit = true;
            }
        }
    }
</script>

<style scoped>

</style>
